/**
* @ngdoc component
* @name common.component:itxContactSubject
* @description
* Component description
*/
(function() {
  'use strict';

  var itxContactSubject = {
    bindings: {
      model:'=',
      form:'='
    },
    controller:   itxContactSubjectCtrl,
    templateUrl: 'contact-subject.component.html'
  };

  itxContactSubjectCtrl.$inject = [];

  function itxContactSubjectCtrl () {
    var _this = this;

    _this.$onInit = function () {
    };

  }

  angular.module('itxApp.common')
  .component('itxContactSubject',itxContactSubject);

})();